import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HeroBanner from '../../../common/heroBanner';
import { SuccessStoriesContextConsumer } from '../../../common/context/success-stories/context';
import { SuccessStoriesStateInterface } from '../../../common/context/success-stories/interface';

const StoryBanner = ({
  partnerDetail = SuccessStoriesStateInterface.partnerDetail,
  loading,
}) => {
  const { headline = '', display_name: displayName, contact_link: contactLink } = partnerDetail || {};
  const { t: translate } = useTranslation('success_story');

  return (
    <HeroBanner page="story" loading={loading} translate={translate} contactLink={contactLink} displayName={displayName} title={headline} />
  );
};
StoryBanner.propTypes = {
  partnerDetail: PropTypes.shape({}),
  loading: PropTypes.bool,
};
StoryBanner.defaultProps = {
  partnerDetail: {},
  loading: false,
};
export default SuccessStoriesContextConsumer(StoryBanner);
